export const DD_CONSTANTS = {
    DISABLED_TOOLTIP: 'Select a member to change the access type',
    EDITOR_TEXT: 'Editor',
    EDITOR_DESCRIPTION: 'Can edit and publish articles',
    VISITOR_TEXT: 'Viewer',
    MEMBER_ROLE: 'MEMBER',
    VIEWER_ROLE: 'VIEWER',
    VISITOR_DESCRIPTION: 'Cannot edit and publish articles',
}

export const DD_OPTIONS = [
    {
        id: DD_CONSTANTS.MEMBER_ROLE,
        text: DD_CONSTANTS.EDITOR_TEXT,
        description: DD_CONSTANTS.EDITOR_DESCRIPTION,
    },
    {
        id: DD_CONSTANTS.VIEWER_ROLE,
        text: DD_CONSTANTS.VISITOR_TEXT,
        description: DD_CONSTANTS.VISITOR_DESCRIPTION,
    }
]